import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32e196d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemInfo = _resolveComponent("ItemInfo")!
  const _component_ContentsInfo = _resolveComponent("ContentsInfo")!
  const _component_MetadataInfo = _resolveComponent("MetadataInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ItemInfo, { item: _ctx.item }, null, 8, ["item"]),
    _hoisted_1,
    _createVNode(_component_ContentsInfo, { contents: _ctx.contents }, null, 8, ["contents"]),
    _hoisted_2,
    _createVNode(_component_MetadataInfo, {
      metadata: _ctx.metadata,
      contents: _ctx.contents
    }, null, 8, ["metadata", "contents"])
  ], 64))
}